import { render } from "./PPromotionPoster.vue?vue&type=template&id=ffd27370&scoped=true"
import script from "./PPromotionPoster.vue?vue&type=script&lang=js"
export * from "./PPromotionPoster.vue?vue&type=script&lang=js"

import "./PPromotionPoster.vue?vue&type=style&index=0&id=ffd27370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd27370"]])

export default __exports__